module.exports = __webpack_public_path__ + "static/media/buttonBgDark.b17b63f7.png";